<template>
<div class="hello">
    <Menu></Menu>
    <div class="class">
        <!-- <div class="page-top-wrap"> -->
        <!-- <div class="top wrap clear">
                <h2 class="bold  float-left">E-mail Template</h2><br>
                <p>상황에 맞는 E-mail Template을 선택 한 후,<br>나의 상황에 맞게 수저앟여 손쉽게 E-mail을 보내 보세요!</p>
            </div> -->
        <div class="top wrap">
            <h2 class="bold  float-left">E-mail Template</h2><br>
            <p>상황에 맞는 E-mail Template을 선택 한 후,<br>나의 상황에 맞게 수정하여 손쉽게 E-mail을 보내 보세요!</p>
        </div>
        <!-- </div> -->

        <div class="page-top-wrap-email mt-20">
            <div class="email-wrap">
                <div class="add-box">
                    <select class="select_icon" v-model="cate" v-on:change="setCategory()">
                        <option value="0">카테고리 선택</option>
                        <option v-for="(item,index) in catlist" :key="index" v-bind:value="item.seq">{{item.en_name}}({{item.kor_name}})</option>
                    </select>
                </div>
                <div class="add-box">
                    <select v-model="sidx" v-on:change="getContent()">
                        <option value="0">Topic을 선택하세요.</option>
                        <option v-for="(item,index) in contlistview" v-bind:value="item.seq" :key="index">{{item.topic_title}}</option>
                    </select>
                </div>
                <div class="add-box pl-25" v-if="emailTemplate==''">
                    Category와 Topic을 선택해주세요.
                    <!-- <textarea placeholder="카테고리와 Topic을 선택해 주세요."></textarea> -->
                </div>
                <div class="add-box pl-25" v-if="emailTemplate!=''">
                    <textarea placeholder="카테고리와 Topic을 선택해 주세요." v-model="emailTemplate"></textarea>
                </div>
            </div>
        </div>
        <div class="wrap pt-20 email-btn">
            <button class="cancel" @click="copy()">복사하기</button>
            <button class="add ml-10" @click="showEmailPop()">내 E-mail로 보내기</button>
        </div>

    </div>

    <!-- 푸터 -->
    <div class="footer clear">
        Copyright© <span class="bold">CARROT</span> Global Inc. All rights reserved.<br>
    </div>
    <Email :visible="is_email" :templete="emailTemplate" @close="is_email=false"></Email>
</div>
</template>

<script>
import Menu from '../components/inc_menu.vue'
import Email from '../components/pop_email.vue'
export default {
    name: 'EmailAdd',
    components: {
        Menu,
        Email
    },
    props: {
        msg: String
    },
    data: () => ({
        contlistview: [],
        emailTemplate: "",
        emailTemplateText: "",
        cate: "0",
        catlist: [],
        sidx: "",
        is_email: false
    }),
    created() {
        if(location.hostname == "stagest.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
        }else if(location.hostname == "st.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "student.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "m.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.href.includes("how")){
            if(location.href.includes("stage")){
                this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            }else{
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }
        }else{
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }
        this.$store.commit("loginCheck");
    },
    mounted() {
        //    this.doc_del_rendar();
        this.getCategory();
    },
    methods: {
        copy() {
            // console.log(this.emailTemplate);
            if (this.emailTemplate == "") {
                alert("Catrgory와 Topic을 선택해주세요.");
                return false;
            }
            var t = document.createElement("textarea");
            document.body.appendChild(t);
            t.value = this.emailTemplate;
            t.select();
            document.execCommand('copy');
            document.body.removeChild(t);
            alert("복사 되었습니다.");
        },
        showEmailPop: function () {
            if (!this.cate || !this.sidx) {
                alert("e-Mail Template 를 선택해주세요.");
                return;
            }
            if(this.emailTemplate == ""){
                alert("템플릿 내용을 입력해주세요.");
                return false;
            }
            this.is_email = true;
        },
        getCategory: function () {
            var me = this;
            this.axios.get(this.$store.state.host + '/rest/mobile/emailTemplate').then(function (res) {
                if (res.data.err == 0) {
                    me.catlist = res.data.cat;
                    me.sidx = 0;
                    console.log(me.catlist);
                }
            });
        },
        setCategory: function () {
            var params = {
                cat: this.cate
            }
            var me = this;
            this.sidx = 0;
            this.emailTemplate = '';
            this.axios.get(this.$store.state.host + '/rest/mobile/emailTemplateContents', {
                params: params
            }).then(function (res) {
                if (res.data.err == 0) {
                    me.contlistview = res.data.list;
                    console.log(me.contlistview);
                }
            });
        },
        getContent: function () {
            var params = {
                cat: this.cate,
                seq: this.sidx
            }
            var me = this;
            this.axios.get(this.$store.state.host + '/rest/mobile/emailTemplateContentView', {
                params: params
            }).then(function (res) {
                if (res.data.err == 0) {
                    me.emailTemplate = res.data.content;
                    me.emailTemplateText = res.data.text;
                    // var newText = oriText.replace(/(<([^>]+)>)/ig,"");
                    me.emailTemplate = me.emailTemplate.replace(/(<([^>]+)>)/ig, "");
                    console.log(me.emailTemplate);
                }
            });
        },
    }
    //   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap');

$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9;
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

.class {
    padding-bottom: 60px;
    width: 1200px;
    margin: 0 auto;

    .floating-write {
        position: fixed;
        right: 0;
        cursor: pointer;
        bottom: 0;
    }

    // .page-top-wrap {
    //     width: 100%;
    //     border-bottom: 10px solid #F5F5F5;

    .top {
        // padding-right: 20px;
        padding-top: 70px;
        border-bottom: 10px solid #f5f5f5;;
        background: url("../assets/img/top-bg.png") no-repeat right -80px;
        padding-bottom: 20px;
        background-size: 300px;
        position: relative;

        .my-reason {
            position: absolute;
            right: 0;
            bottom: 15%;
        }

        p {
            font-size: 14px;
            letter-spacing: 0px;
            color: #000000;
            opacity: 1;
            margin-top: 20px;
        }

        div {
            select {
                border: 1px solid var(--unnamed-color-53caff);
                background: #FFFFFF 0% 0% no-repeat padding-box;
                border: 1px solid #53CAFF;
                border-radius: 4px;
                opacity: 1;
                color: #53CAFF;
                ;
            }
        }
    }

    .wrap {
        width: 100%;
        max-width: 700px;
        margin: 0 auto;
    }

    // }

    .page-top {
        border-bottom: 1px solid #E9E9E9;

        .review-top {

            div {
                background: #F5F5F5 0% 0% no-repeat padding-box;
                border: 1px solid #E9E9E9;
                border-radius: 10px;
                opacity: 1;
                width: 95%;
                margin: 0 auto;
                box-sizing: border-box;
                padding-top: 19px;
                padding-bottom: 19px;

                p {
                    float: left;
                    text-align: center;

                    &:first-child {
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #B7B7B7;
                        opacity: 1;
                    }

                    &:last-child {
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #000000;
                        opacity: 1;
                    }
                }
            }
        }
    }

    .page-top-wrap-email {
        width: 90%;
        max-width: 700px;
        margin: 0 auto;

        .none-email {
            display: table;
            min-height: 300px;
            width: 100%;

            p {
                display: table-cell;
                vertical-align: middle;
                text-align: center;
                color: var(--unnamed-color-b7b7b7);
                text-align: center;
                font-size: 16px;
                font-weight: bold;
                letter-spacing: 0px;
                color: #B7B7B7;
                opacity: 1;
            }
        }

        .email-wrap {
            .add-box {
                width: 100%;
                border-bottom: 1px solid #E9E9E9;
                padding-top: 15px;
                padding-bottom: 15px;
                padding-left: 20px;
                padding-right: 20px;
                position: relative;

                select {
                    width: 100%;
                    border: none;
                    font-size: 16px;
                    letter-spacing: 0px;
                    color: #000000;
                    background: white;
                    opacity: 1;
                    padding-left: 0;
                }

                input[type="text"],
                input[type="password"] {
                    border-radius: 0;
                    border-top: none;
                    border-right: none;
                    border-left: none;
                    border-bottom: none;
                    font-size: 16px;
                    padding: 0 10px;
                }

                .file {
                    position: absolute;
                    right: 0;
                    right: 20px;
                }

                a {
                    font-size: 14px;
                    letter-spacing: 0px;
                    color: #53CAFF;
                    opacity: 1;
                }

                textarea {
                    width: 100%;
                    border: none;
                    height: 500px;
                    font-size: 16px;
                    color: black;
                    resize: none;
                }

                .point-color {
                    color: #5d9cec;
                    ;
                }

                &:last-child {
                    // border-bottom: 0px solid #E9E9E9;
                }
            }
        }

    }

    .email-btn {
        text-align: center;

        button {
            text-align: center;
            font-size: 14px;
            letter-spacing: 0px;
            color: #FFFFFF;
            opacity: 1;
            border: none;
            padding: 5px 10px;
            cursor: pointer;
        }

        .cancel {
            background: #6974FF 0% 0% no-repeat padding-box;
            border-radius: 3px;
            opacity: 1;
        }

        .add {
            background: #53CAFF 0% 0% no-repeat padding-box;
            border-radius: 3px;
            opacity: 1;
        }
    }
}

.point-color {
    color: #5d9cec;
    ;
}

.btn-base-white {
    padding: 5px;
}

.footer {
    position: static;
}

@media only screen and (max-width: 414px) {
    .class {
        width: 100%;

        .top {
            background: url("../assets/img/top-bg.png") no-repeat 160px -80px;
            background-size: 300px;

            &.wrap {
                width: 100%;
                padding-left: 5%;
                max-width: none;
            }
        }

        .page-top-wrap-email {
            width: 100%;
        }
    }
}
</style>
